<template>
<div>
  <section class="hero is-primary" id="head-section">
    <div class="hero-body">
      <div class="container has-text-centered">
        <h2 class="title">欢迎使用DiNi观测数据水准网平差服务</h2>
      </div>
    </div>
  </section>

<div class="notification" v-if="showMessage">
  <button class="delete" @click="closeNotif"></button>
  {{ message }}
</div>
<div class="card">
  <header class="card-header">
    <p class="card-header-title">
      请输入券码
    </p>
  </header>
  <div class="card-content">
    <input class="input" type="text" placeholder="8位字符串" v-model="code">
  </div>
  <div class="card-footer">
    <a
      class="card-footer-item"
      href="https://k.ruyu.com/ak6uJXFF"
    >
      商城
    </a>
    <button
      class="card-footer-item"
      :disabled="!isItRedeemCode"
      @click="bindRedeem"
    >
      绑定
    </button>
  </div>
</div>

</div>
</template>

<script>
export default {
  data () {
    return {
      code: '',
      showMessage: false,
      message: ''
    }
  },
  methods: {
    bindRedeem (evt) {
      evt.preventDefault()
      console.log('print this.code = ' + this.code)
      this.$store.dispatch('submitRedeem', this.code)
        .then(() => this.$router.push('/Home'))
        .catch(error => {
          console.log('Error Posting: ', error)
          this.showMessage = true
          this.message = '出现了一个错误: ' + error.response.data['error']
        })
    },
    closeNotif (evt) {
      // evt.preventDefault()
      this.showMessage = false
    },
    isIt8AsciiCode (input) {
      const re = /^[0-9a-zA-Z]{8}$/
      return re.test(input)
    }
  },
  computed: {
    isItRedeemCode () {
      return this.isIt8AsciiCode(this.code)
    }
  }
}
</script>

<style>
button.card-footer-item {
  background-color: transparent;
  cursor: pointer;
  color: link;
  border: 0;
  font-size: 1rem;
  line-height: 1.5;
}
</style>



// WEBPACK FOOTER //
// src/components/Unbound.vue